// icons
import { MdLibraryBooks, MdPerson, MdPeople, MdCode } from "react-icons/md";

const catalogos = {
  id: 'catalogos-group',
  type: 'group',
  roles: [1, 100],
  breadcrumbs: false,
  children: [
    {
      id: 'catalogos',
      title: "Catálogos",
      type: 'collapse',
      icon: MdLibraryBooks,
      children: [
        {
          id: 'usuarios',
          title: "Usuarios",
          type: 'item',
          breadcrumbs: false,
          icon: MdPerson,
          url: '/catalogos/usuarios'
        },
        {
          id: 'clientes',
          title: "Clientes",
          type: 'item',
          breadcrumbs: false,
          icon: MdPeople,
          url: '/catalogos/clientes'
        },
        {
          id: 'proyectos',
          title: "Proyectos",
          type: 'item',
          breadcrumbs: false,
          icon: MdLibraryBooks,
          url: '/catalogos/proyectos'
        },
        {
          id: 'contextos-ia',
          title: "Contextos IA",
          type: 'item',
          breadcrumbs: false,
          icon: MdCode,
          url: '/catalogos/contextos-ia'
        }
      ]
    }
  ]
};

export default catalogos;
